/* oxlint-disable typescript/consistent-type-assertions -- lint to the future batch ignore */
/* oxlint-disable typescript/no-explicit-any -- interfacing with untyped Ember models during migration */
/* oxlint-disable typescript/no-unsafe-assignment -- interfacing with untyped Ember models during migration */
/* oxlint-disable typescript/no-unsafe-member-access -- interfacing with untyped Ember models during migration */

import { useQuery } from '@tanstack/react-query';
import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';

export interface UseEmberRegistrationResult {
  registration: any;
  isLoading: boolean;
  error: unknown;
  isError: boolean;
}

export function useEmberRegistration(
  registrationId: string | undefined
): UseEmberRegistrationResult {
  const store = useEmberService('store') as any;

  const {
    data: registration,
    isLoading,
    error,
    isError,
  } = useQuery({
    queryKey: ['registration', registrationId],
    queryFn: async () => {
      if (!registrationId) {
        throw new Error('Registration ID is required');
      }

      // Try to peek the record first (for navigation flow)
      let registrationRecord =
        store.peekRecord('registration', registrationId) ||
        store.peekRecord('partner-registration', registrationId);

      // If not found in store, fetch from API (for page refresh)
      if (!registrationRecord) {
        try {
          registrationRecord = await store.findRecord('registration', registrationId, {
            include: 'stakeholders',
            reload: true,
          });

          // Ensure organization is loaded
          await store.findAll('organization');
        } catch {
          // Fallback to partner-registration
          registrationRecord = await store.findRecord('partner-registration', registrationId, {
            reload: true,
          });

          // Load required relationships for partner-registration
          const organization = await registrationRecord.get('organization');
          await organization.get('owner');
        }
      }
      // oxlint-disable-next-line typescript/no-unsafe-return -- interfacing with untyped Ember models during migration
      return registrationRecord;
    },
    enabled: Boolean(registrationId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    registration,
    isLoading,
    error,
    isError,
  };
}
